import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, FormGroup, Label, Button, Input, Container, Row, Col} from "reactstrap";
import {AvField, AvForm} from 'availity-reactstrap-validation';
import * as authActions from "../redux/actions/AuthActions";
import {connect} from "react-redux";

class Login extends Component {

    handleSignIn = async (e, v) => {
        console.log(v);
        this.props.dispatch(authActions.login({v, history: this.props.history}))
    };

    render() {
        const login = () => {
            console.log("OK")
        }

        return (
            <div>
                <Container>
                    <Row>
                        <Col md={{size: 6, offset: 3}}>
                            <AvForm onValidSubmit={this.handleSignIn}>
                                <h1 className={"text-center"}>Login</h1>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label for="exampleEmail" className="mr-sm-2">Telefon raqam</Label>
                                    <AvField type="text" name="phoneNumber" placeholder="+998 90 1234567" required/>
                                </FormGroup>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label for="examplePassword" className="mr-sm-2">Parol</Label>
                                    <AvField type="password" name="password" placeholder="Parol" required/>
                                </FormGroup>
                                <hr/>
                                <Button color={"primary"}>Submit</Button>
                            </AvForm>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

Login.propTypes = {};


export default connect(
    ({
         app: {showModal},
         auth: {isAdmin, isSuperAdmin, currentUser}
     }) => ({
        showModal,
        isAdmin,
        isSuperAdmin,
        currentUser
    })
)(Login);
